import React from 'react';
import ReactDOM from 'react-dom/client';
import Atlas from './atlas.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <Atlas />
);
